// meters per unit for different projections
export const METERS_PER_UNIT: { [key: string]: number } = {
  'EPSG:3857': 1,
};
